module.exports = __webpack_public_path__ + "img/SKMJ_saferoad8.4033f31e.jpg";